import { render } from "./VideoProcessingPlayer.vue?vue&type=template&id=6ff37106&ts=true"
import script from "./VideoProcessingPlayer.vue?vue&type=script&lang=ts"
export * from "./VideoProcessingPlayer.vue?vue&type=script&lang=ts"

import "./VideoProcessingPlayer.vue?vue&type=style&index=0&id=6ff37106&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__